/* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colours = tokens.colors;
var bodyBold = designTokenFonts.bodyBold,
  mini = designTokenFonts.mini;
export var container = /*#__PURE__*/css("display:flex;flex-direction:column;justify-content:space-between;width:230px;background-color:", colours.neutral.surface.default, ";border:1px solid ", colours.neutral.trim.default, ";padding:12px;cursor:pointer;");
export var logo = {
  name: "1w3qbvd",
  styles: "max-width:120px;max-height:42px;"
};
export var agent = {
  name: "knzbj2",
  styles: "display:flex;flex-direction:row;gap:10px;"
};
export var avatar = {
  name: "v3ru9z",
  styles: "display:inline-block;width:50px;height:50px;"
};
export var nameTitle = {
  name: "r61du8",
  styles: "width:129px;"
};
export var agentName = /*#__PURE__*/css("display:-webkit-box;", bodyBold, ";color:", colours.neutral.heavy.default, ";overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:2;-webkit-box-orient:vertical;");
export var jobTitle = /*#__PURE__*/css(mini, ";color:", colours.neutral.medium.default, ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;");
export var bottom = {
  name: "19sy0l7",
  styles: "display:flex;flex-direction:row;margin-top:8px;"
};
export var checkbox = {
  name: "42igfv",
  styles: "margin:auto;"
};
export var nameAddress = {
  name: "17c0jvt",
  styles: "width:161px;"
};
export var agencyName = /*#__PURE__*/css(bodyBold, ";color:", colours.neutral.heavy.default, ";white-space:nowrap;overflow:hidden;text-overflow:ellipsis;");
export var address = /*#__PURE__*/css(mini, ";color:", colours.neutral.medium.default, ";");